export const privacyPolicyObjArabic = {
  topSubHeading: "توقف عن دفع رواتب بقيمة 100 ألف دولار",
  heading: "نحن نقدم مكالمة استشارية مجانية",
  subHeading:
    "احصل على مكالمة استشارية مجانية لمشروعك أو أي تحدي تقني تواجهه. قدم بريدك الإلكتروني، وسيساعدك أفضل مهندسينا!",
  emailLabel: "بريدك الإلكتروني الوظيفي",
  submitBtn: "إرسال",
  loading: "جاري التحميل...",
};

export const cookiesObjArabic = {
  heading: "خصوصيتك",
  description:
    "تستخدم Bitsclan الكوكيز الأساسية والتقنيات المماثلة لضمان تشغيل موقعنا الإلكتروني بشكل اختياري وتقديم تجربة مستخدم مخصصة. لمزيد من المعلومات، يرجى مراجعة",
  policyLink: "السياسة",
  acceptBtn: "قبول",
  rejectBtn: "رفض",
};
